/* Calculadora de laminas. Los valores por zona replican la tabla que ya estaba
   publicada en la ficha (2 puertas delanteras = 5, 4 puertas = 10, piso = 10).
   La superficie por lamina y la existencia del Pack 5 varian por linea, asi que
   cada plantilla las declara en el contenedor:
     <div class="sbc" data-area="0.40" data-pack5="no">
   Sin esos atributos se asume la lamina de butilo: 46 x 80 cm con Pack 5. */
(function(){
  function root(){return document.querySelector('.sbc');}
  function area(){
    var r=root();
    var v=r&&r.dataset.area?parseFloat(r.dataset.area):NaN;
    return isNaN(v)||v<=0?0.368:v;
  }
  function hayPack5(){
    var r=root();
    return !(r&&r.dataset.pack5==='no');
  }

  function chips(g){return Array.from(document.querySelectorAll('[data-sbc-g="'+g+'"] .sbc__c'));}
  function activos(g){return chips(g).filter(function(c){return c.getAttribute('aria-pressed')==='true';});}
  function norm(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/\s+/g,' ').trim();}

  function calcular(){
    var out=document.querySelector('[data-sbc-out]');
    if(!out){return;}
    var v=activos('auto')[0];
    var mult=v?parseFloat(v.dataset.v):1;
    var base=activos('zonas').reduce(function(a,c){return a+parseInt(c.dataset.l,10);},0);
    var eN=out.querySelector('[data-sbc-n]'), eM=out.querySelector('[data-sbc-m]'),
        eP=out.querySelector('[data-sbc-p]'), btn=out.querySelector('[data-sbc-ir]');
    if(!base){
      eN.textContent='—';
      eM.textContent='';
      eP.textContent='Elige al menos una zona';
      btn.disabled=true;
      btn.textContent='Elegir pack';
      return;
    }
    var n=Math.ceil(base*mult);
    btn.disabled=false;
    eN.textContent=n+' lámina'+(n===1?'':'s');
    eM.textContent=(n*area()).toFixed(2).replace('.',',')+' m²';
    var pack,txt,lbl;
    if(n>=8){
      pack='Pack 10 + rodillo';
      lbl='Elegir Pack 10';
      txt = n>10 ? '<b>'+Math.ceil(n/10)+' Packs de 10</b>' : '<b>Pack 10 + rodillo</b>';
    }else if(n>=4&&hayPack5()){
      pack='Pack 5 láminas'; lbl='Elegir Pack 5'; txt='<b>Pack 5 láminas</b>';
    }else{
      pack='1 lámina'; lbl='Elegir 1 lámina'; txt='<b>'+n+' lámina'+(n===1?'':'s')+' sueltas</b>';
    }
    eP.innerHTML=txt;
    btn.dataset.pack=pack;
    btn.textContent=lbl;
  }

  function elegir(pack){
    var lbl=Array.from(document.querySelectorAll('.label-swatch')).find(function(l){
      return norm(l.getAttribute('title'))===norm(pack);
    });
    if(lbl){try{lbl.click();}catch(e){}}
    var t=document.querySelector('.variant-input-wrapper');
    if(!t){return;}
    var r=t.getBoundingClientRect();
    if(r.top>=0&&r.bottom<=window.innerHeight){return;}
    var top=Math.max(0,r.top+window.scrollY-110);
    try{window.scrollTo({top:top,behavior:'smooth'});}catch(e){window.scrollTo(0,top);}
    setTimeout(function(){if(Math.abs(window.scrollY-top)>80){window.scrollTo(0,top);}},900);
  }

  document.addEventListener('click',function(e){
    if(!e.target.closest){return;}
    var ir=e.target.closest('[data-sbc-ir]');
    if(ir){elegir(ir.dataset.pack||'Pack 10 + rodillo');return;}
    var c=e.target.closest('.sbc__c');
    if(!c||!c.parentElement){return;}
    var g=c.parentElement.dataset.sbcG;
    if(g==='zonas'){
      c.setAttribute('aria-pressed',c.getAttribute('aria-pressed')==='true'?'false':'true');
    }else{
      chips(g).forEach(function(x){x.setAttribute('aria-pressed','false');});
      c.setAttribute('aria-pressed','true');
    }
    calcular();
  });

  if(document.readyState!=='loading'){calcular();}else{document.addEventListener('DOMContentLoaded',calcular);}
  [400,1200].forEach(function(d){setTimeout(calcular,d);});
})();
